const state = {
  data: {},
};

const getters = {
  get: state => (key) => {
    if(key === undefined)
      return state.data

    return state.data[key] !== undefined && state.data[key] !== null ? state.data[key] : null;
  },
};

const mutations = {
  SET(state, data) {
    state.data = _.isPlainObject(data) ? data : {};
  },
};

const actions = {
  set({ commit }, data) {
    commit('SET', data)
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
